import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'objectAsArray',  pure: false })
export class ObjectAsArrayPipe implements PipeTransform {
	transform(value: any, args: any[] = null): any {
		return Object.keys(value).map(key => value[key]);
	}
}
